import { Input as InputPrimitive } from "@base-ui/react/input";

import { cx } from "../../cx";
import styles from "./input.module.css";

export type InputSize = "sm" | "default" | "lg";
/** `bare` sits inside a frame the page draws (a search form with an icon):
 *  no border, fill, height or focus ring of its own — the frame shows focus
 *  through `:focus-within`. */
export type InputVariant = "default" | "bare";

interface InputProps extends Omit<InputPrimitive.Props, "className" | "size"> {
  className?: string;
  size?: InputSize;
  variant?: InputVariant;
}

function Input({
  className,
  size = "default",
  variant = "default",
  ...props
}: InputProps) {
  return (
    <InputPrimitive
      data-tui=""
      data-slot="input"
      data-size={size}
      data-variant={variant}
      className={cx(styles.input, className)}
      {...props}
    />
  );
}

export { Input };
